import {Formik} from 'formik'
import {FC, useCallback, useEffect, useState} from 'react'
import {
  useAdminUpdateFraudKeywordMutation,
  useLazyAdminGetFraudKeywordQuery,
} from '../../../../../services/cellcast.v2'
import {toast} from 'react-toastify'
import {Alert, Spinner} from 'react-bootstrap'

const FraudKeywordPage: FC = () => {
  const [keywords, setKeywords] = useState('')

  const [fetchData, getResponse] = useLazyAdminGetFraudKeywordQuery()
  const [updateData, updateResponse] = useAdminUpdateFraudKeywordMutation()
  const [actionError, setActionError] = useState('')

  const handleUpdate = useCallback(() => {
    setActionError('')
    updateData({keywords}).then((res) => {
      if ('data' in res) {
        if (res.data?.error && Object.keys(res.data?.error).length > 0) {
          setActionError(res?.data?.message)
        } else {
          toast.success(res?.data?.message)
          fetchData(null)
        }
      } else if ('error' in res) {
        const resError = res.error as any
        if (resError.data?.message) {
          setActionError(resError.data?.message || '')
        } else {
          setActionError(res?.error.toString() || '')
        }
      }
    })
  }, [keywords])

  useEffect(() => {
    fetchData(null).then((res) => {
      if ('data' in res) {
        if (res.data?.error && Object.keys(res.data?.error).length > 0) {
          toast.error(res?.data?.message)
        }
      } else if ('error' in res) {
        toast.error(res.error?.toString())
      }
    })
  }, [])

  useEffect(() => {
    if (getResponse.data && getResponse.data.data) {
      setKeywords(getResponse.data.data)
    }
  }, [getResponse.data])

  return (
    <div className='card'>
      <div className='card-header card-header-stretch border-bottom-0'>
        <div className='card-title d-flex align-items-center'>
          <h3 className='fw-bolder m-0 text-gray-600-800'>Fraud Keyword</h3>
        </div>
      </div>
      <div className='card-body pt-0'>
        {actionError !== '' && (
          <div className='card-toolbar align-items-center'>
            <div className='p-10 pb-0'>
              <Alert variant='danger'>{actionError} </Alert>
            </div>
          </div>
        )}

        <div className='row p-5'>
          {getResponse && getResponse.isLoading ? (
            <Spinner />
          ) : (
            <div className='row'>
              <div className='col-12'>
                <h5 className='text-gray-600 mb-5'>Configure Fraud Keyword</h5>
                <textarea
                  placeholder={'input your fraud keywords'}
                  className={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                  value={keywords}
                  rows={10}
                  onChange={(e) => setKeywords(e.currentTarget.value)}
                />
              </div>
            </div>
          )}
        </div>
        <div className='modal-footer d-flex justify-content-center'>
          <button
            type='submit'
            className='btn btn-primary ml-2'
            onClick={handleUpdate}
            disabled={updateResponse && updateResponse.isLoading}
          >
            {updateResponse && updateResponse.isLoading ? <Spinner /> : 'update'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default FraudKeywordPage
